module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 44
// module chunks = 0 1 3 4 5 6 8 9 10 12 14 17 18 19 20 21 22 24 25 26 28 29 30 31